import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm sticky top-0 z-50 backdrop-blur-sm bg-white/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="text-pink-400 font-bold text-4xl hover:text-pink-500 transition-colors">
            KinAlma
          </Link>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
          <p className="text-gray-600 text-lg">Effective Date: April 17, 2025</p>
          
          <div className="prose prose-lg max-w-none space-y-6 text-gray-700">
            <p className="text-lg leading-relaxed">
              KinAlma ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our mobile application ("App"). By using KinAlma, you agree to the practices described in this policy.
            </p>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-900">1. Information We Collect</h2>
              <p>We may collect the following types of information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><span className="font-medium">Personal Information:</span> When you create an account or use features like album sharing, we may collect your name, email address, and other identifying details.</li>
                <li><span className="font-medium">Photos and Media:</span> Our app allows you to upload and organize photos. These are stored securely and are not shared without your permission.</li>
                <li><span className="font-medium">Usage Data:</span> We may collect information about how you use the app to improve the user experience.</li>
                <li><span className="font-medium">Device Information:</span> Information such as device type, operating system, and app version may be collected for analytics and troubleshooting.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-900">2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide and maintain the functionality of KinAlma.</li>
                <li>Allow you to create and manage photo albums.</li>
                <li>Improve app performance and user experience.</li>
                <li>Communicate with you regarding updates, support, and promotional content (if you opt-in).</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-900">3. How We Share Your Information</h2>
              <p>We do not sell or rent your personal data. Your information may be shared only in the following scenarios:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><span className="font-medium">With Your Consent:</span> You choose to share albums or photos.</li>
                <li><span className="font-medium">Service Providers:</span> We may use trusted third-party services for hosting, analytics, or support.</li>
                <li><span className="font-medium">Legal Obligations:</span> If required by law, we may disclose your information.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-900">4. Data Security</h2>
              <p>We implement appropriate security measures to protect your information, including encrypted storage and secure data transfer methods. However, no system is 100% secure, and we cannot guarantee absolute security.</p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-900">5. Your Rights and Choices</h2>
              <p>Depending on your location, you may have rights such as:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Accessing or correcting your data.</li>
                <li>Deleting your account and associated data.</li>
                <li>Opting out of certain data uses.</li>
              </ul>
              <p>You can manage many of these settings directly within the app or by contacting us.</p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-900">6. Children’s Privacy</h2>
              <p>KinAlma is not intended for use by children under the age of 13 (or the equivalent minimum age in your jurisdiction). We do not knowingly collect data from children without parental consent.</p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-900">7. Changes to This Policy</h2>
              <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy in the app or via email.</p>
            </section>

            <section className="mt-8 border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-semibold text-gray-900">8. Contact Us</h2>
              <p className="mt-4">
                If you have any questions or concerns about this Privacy Policy, please contact us at:{' '}
                <a href="mailto:accounts@kinalma.com" className="text-pink-600 hover:text-pink-700 transition-colors">
                  accounts@kinalma.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
